import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PayInResource } from './types';

export default (makeCall: MakeCall) => (uuid: string) =>
  makeCall<PayInResource>('GET', `/api/v2/payment/pay-in/${uuid}`);
